import DocumentClassificationSection from './sections/DocumentClassificationSection.vue'
import DocumentPreview from './DocumentPreview.vue'
import GuidedDocumentInformationSection from './sections/GuidedDocumentInformationSection.vue'
import GuidedProductsReviewSection from './products/GuidedProductsReviewSection.vue'
import ProductsReviewSection from './products/ProductsReviewSection.vue'
import GuidedRegulationsReviewSection from './regulations/GuidedRegulationsReviewSection.vue'
import RegulationsReviewSection from './regulations/RegulationsReviewSection.vue'
import ScipInformationSection from './sections/ScipInformationSection.vue'
import SubstancesReviewSection from './substances/SubstancesReviewSection.vue'

const DocumentComplianceSection = Object.freeze({
    DOCUMENT_PREVIEW: 'document-preview',
    DOCUMENT_INFORMATION: 'document-information',
    REGULATIONS: 'regulations',
    SCIP_INFORMATION: 'scip-information',
    SUBSTANCES: 'substances',
    PRODUCTS: 'products',
})

const DocumentComplianceSectionVariant = Object.freeze({
    STANDARD_V1: 'standard-v1',
    GUIDED_V1: 'guided-v1',
})

const DEFAULT_DOCUMENT_COMPLIANCE_SECTION_VARIANTS = Object.freeze({
    [DocumentComplianceSection.DOCUMENT_PREVIEW]: DocumentComplianceSectionVariant.STANDARD_V1,
    [DocumentComplianceSection.DOCUMENT_INFORMATION]: DocumentComplianceSectionVariant.STANDARD_V1,
    [DocumentComplianceSection.REGULATIONS]: DocumentComplianceSectionVariant.STANDARD_V1,
    [DocumentComplianceSection.SCIP_INFORMATION]: DocumentComplianceSectionVariant.STANDARD_V1,
    [DocumentComplianceSection.SUBSTANCES]: DocumentComplianceSectionVariant.STANDARD_V1,
    [DocumentComplianceSection.PRODUCTS]: DocumentComplianceSectionVariant.STANDARD_V1,
})

const DOCUMENT_COMPLIANCE_SECTION_REGISTRY = Object.freeze({
    [DocumentComplianceSection.DOCUMENT_PREVIEW]: Object.freeze({
        [DocumentComplianceSectionVariant.STANDARD_V1]: DocumentPreview,
    }),
    [DocumentComplianceSection.DOCUMENT_INFORMATION]: Object.freeze({
        [DocumentComplianceSectionVariant.STANDARD_V1]: DocumentClassificationSection,
        [DocumentComplianceSectionVariant.GUIDED_V1]: GuidedDocumentInformationSection,
    }),
    [DocumentComplianceSection.REGULATIONS]: Object.freeze({
        [DocumentComplianceSectionVariant.STANDARD_V1]: RegulationsReviewSection,
        [DocumentComplianceSectionVariant.GUIDED_V1]: GuidedRegulationsReviewSection,
    }),
    [DocumentComplianceSection.SCIP_INFORMATION]: Object.freeze({
        [DocumentComplianceSectionVariant.STANDARD_V1]: ScipInformationSection,
    }),
    [DocumentComplianceSection.SUBSTANCES]: Object.freeze({
        [DocumentComplianceSectionVariant.STANDARD_V1]: SubstancesReviewSection,
    }),
    [DocumentComplianceSection.PRODUCTS]: Object.freeze({
        [DocumentComplianceSectionVariant.STANDARD_V1]: ProductsReviewSection,
        [DocumentComplianceSectionVariant.GUIDED_V1]: GuidedProductsReviewSection,
    }),
})

const resolveDocumentComplianceSection = (section, variant = null) => {
    const variants = DOCUMENT_COMPLIANCE_SECTION_REGISTRY[section]
    if (!variants) {
        return null
    }

    const resolvedVariant = variant || DEFAULT_DOCUMENT_COMPLIANCE_SECTION_VARIANTS[section]

    return variants[resolvedVariant] || null
}

export {
    DEFAULT_DOCUMENT_COMPLIANCE_SECTION_VARIANTS,
    DocumentComplianceSection,
    DocumentComplianceSectionVariant,
    resolveDocumentComplianceSection,
}
